module.exports = __webpack_public_path__ + "static/media/Logo.e7b1f441.svg";